import { render, staticRenderFns } from "./label-production.vue?vue&type=template&id=3b885b4c"
import script from "./label-production.vue?vue&type=script&lang=js"
export * from "./label-production.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports